// @flow

import { h }             from "preact";
import { PureComponent } from "shared-components";
import styles            from "./styles.scss";
import classNames        from "classnames";

import { growIn,
         shortDuration } from "../../helpers/animations";

export default class Spinner extends PureComponent {
  render(props: Props) {
    return (
      <div
          class={classNames(
            this.props["class"],
            growIn,
            shortDuration,
            styles.block,
          )}>

        <span class={styles.dot} />
        <span class={styles.dot} />
        <span class={styles.dot} />
      </div>
    );
  }
}
